export interface GetAllBoardSettingsRequest {
    boardSlug: string;
    controlType?: string;
}

export interface BoardSettingsCreateEditRequest {
    boardSettingKey: string;
    value: string;
    boardId: string; // Use string for GUIDs in TypeScript
}
export interface BoardSettingsCreateRequest {
    boardSlug: string;
    controlType: string;
}
export enum BoardSettingsKeysWnum {
    TimeTrackerValueKeyBinding = 'TimeTrackerValueKeyBinding',
}

export interface BoardSettingsResponse {
    id: string;
    boardSettingKey: string;
    value: string;
    boardId: string; // Use string for GUIDs in TypeScript
}
export enum BoardSettingsSettingTabsTypeEnum {
    General = 'GENERAL',
    Members = 'MEMBERS',
    BoardDynamicForm = 'BoardDynamicForm',
    ImportExportData = 'ImportExportData',
    TimeTrackerSettings = 'TimeTrackerSettings',
    WebhookSettings = 'WebhookSettings',
}

export enum BoardSettingsKeys {
    BoardWebhookUrl = 'BoardWebhookUrl',
    BordWebhookEventTriggers = 'BordWebhookEventTriggers',
}
